import { createSlice } from "@reduxjs/toolkit";

const initialState = { datas: [] };

export const loadingSlice = createSlice({
  name: "global-loading",
  initialState,
  reducers: {
    addLoading: (state, action) => {
      state.datas.push({
        ...action.payload,
      });
    },

    clearLoading: (state, action) => {
      state.datas = state.datas.filter(
        (loading) => loading.id !== action.payload.id
      );
    },

    clearLoadingAll: (state) => {
      state.datas = [];
    },
  },
});

export const { addLoading, clearLoading, clearLoadingAll } =
  loadingSlice.actions;

export const selectLoadings = (state) => state.loadings.datas;

export default loadingSlice.reducer;
